import { Visit } from './../../../../models/visit.interface';
import { Component, OnInit, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { ModalComponent } from '@shared/components/modal/modal.component';

@Component({
  selector: 'app-debito-aberto-informacao',
  templateUrl: './debito-aberto-informacao.component.html',
  styleUrls: ['./debito-aberto-informacao.component.css']
})
export class DebitoAbertoInformacaoComponent implements OnInit {

  lsClients: any[] = [];

  @ViewChild('debitoAbertotInformacaoComponent', {static: true}) private debitoAbertotInformacaoComponent: ModalComponent;

  @Output() markClick = new EventEmitter()
  @Output() cancelClick = new EventEmitter()

  constructor() { }

  ngOnInit() {
    console.log("Chegou no INIT")
  }

  public open(){
    this.debitoAbertotInformacaoComponent.open()
    console.log("Open")
  }

  public close(){
    this.cancelClick.emit()
    this.debitoAbertotInformacaoComponent.close()
  }

  public handleMarkClick(){
    this.close()
    this.markClick.emit()
  }
  

}
